import { TableSettings } from 'api/api';
import { Action } from 'redux';
import { isType } from 'typescript-fsa';
import * as actions from './actions';
import { allColumns, ServiceHistoryColumnNames, ServiceHistoryTableSettingsState } from './types';

export const initialState: ServiceHistoryTableSettingsState = {
	columnOrder: [
		ServiceHistoryColumnNames.createdOn,
		ServiceHistoryColumnNames.serviceDocumentType,
		ServiceHistoryColumnNames.dateOfService,
		ServiceHistoryColumnNames.comment,
		ServiceHistoryColumnNames.download,
		ServiceHistoryColumnNames.delete,
	],
	columnWidths: [
		{ columnName: ServiceHistoryColumnNames.createdOn, width: 155 },
		{ columnName: ServiceHistoryColumnNames.serviceDocumentType, width: 120 },
		{ columnName: ServiceHistoryColumnNames.dateOfService, width: 100 },
		{ columnName: ServiceHistoryColumnNames.comment, width: NaN },
		{ columnName: ServiceHistoryColumnNames.download, width: 85 },
		{ columnName: ServiceHistoryColumnNames.delete, width: 75 },
	],
	sorting: [
		{
			columnName: ServiceHistoryColumnNames.createdOn,
			direction: 'desc',
		},
	],
	columns: allColumns,
	tableSettings: new TableSettings(),
	loaded: false,
};

export function serviceHistoryTableSettingsReducer(
	state: typeof initialState = initialState,
	action: Action
): typeof initialState {
	if (isType(action, actions.setColumnOrderAction)) {
		return {
			...state,
			columnOrder: action.payload,
		};
	}
	if (isType(action, actions.setColumnSizeAction)) {
		return {
			...state,
			columnWidths: action.payload,
		};
	}
	if (isType(action, actions.setColumnSortingAction)) {
		return {
			...state,
			sorting: action.payload,
		};
	}

	return state;
}
